import script from "./sliderMenuProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./sliderMenuProducts.vue?vue&type=script&setup=true&lang=js"

import "./sliderMenuProducts.vue?vue&type=style&index=0&id=7f7fdbc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7fdbc6"]])

export default __exports__